import { useBoundStore } from '@Store/index';
import { handleLoginResponse } from '@Services/init/handleLoginResponse.ts';
import { getNavigationStackMap } from '../../consts/navigation-stack-map.ts';
import { routesModel } from '@Router/router.consts.ts';
import { router } from '@Routes/__root.tsx';
interface BuildNavigationProps {
  shouldAvoidPickUpWhereLeft?: boolean;
  shouldAvoidNavigation?: boolean;
}
export const buildNavigationStack = async ({
  shouldAvoidPickUpWhereLeft,
  shouldAvoidNavigation,
}: BuildNavigationProps) => {
  const { setNavigationStack, setIsLoginProcessFinished } =
    useBoundStore.getState().onboardingSlice;
  const {
    onboardingStatus,
    customerData: { lastStepData, onboardingTypeEnum },
  } = useBoundStore.getState().customer;
  const navigationStack = getNavigationStackMap();
  setNavigationStack(navigationStack);
  const shouldHandleLogin = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  if (shouldHandleLogin && !shouldAvoidPickUpWhereLeft) {
    handleLoginResponse({ onboardingStatus, onboardingTypeEnum, lastStepData });
    setTimeout(() => {
      setIsLoginProcessFinished(true);
    }, 5000);
  } else if (!shouldAvoidNavigation) {
    router.navigate({ to: routesModel[navigationStack[0]].path });
  }
};
